// Modern audition state only. Never serialized into Fairlight media or exports.
export type PageRMonitoring = { muted: boolean[]; soloed: boolean[] };
export const emptyMonitoring = (): PageRMonitoring => ({ muted: Array(8).fill(false), soloed: Array(8).fill(false) });
export function audibleLanes(state: PageRMonitoring): boolean[] {
  const solo = state.soloed.some(Boolean);
  return Array.from({ length: 8 }, (_, lane) => !state.muted[lane] && (!solo || state.soloed[lane]));
}
